isResponseRange500